import { render, staticRenderFns } from "./AdminListComponent.vue?vue&type=template&id=30c3131a&scoped=true&"
import script from "./AdminListComponent.vue?vue&type=script&lang=js&"
export * from "./AdminListComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminListComponent.vue?vue&type=style&index=0&id=30c3131a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c3131a",
  null
  
)

export default component.exports